<template>
    <footer v-if="!isIframe && !currentUserLoading" class="text-center container-fluid">
        <!-- Help Bubble -->
        <div class="text-right help-bubble">
            <div v-if="seen" class="text-left rounded bubble-cont bg-primary box-form box-shadow">
                <h3 class="text-center bd-title default-letter-spacing text-uppercase font-weight-bold font-md white">Tutorial Videos</h3>
                <ul>
                    <li>
                        <a href="#" class="link-style-white2" @click.prevent="openModal('register')">
                            <i class="align-middle material-icons">play_circle_outline</i> How to Register
                        </a>
                    </li>
                    <li>
                        <a href="#" class="link-style-white2" @click.prevent="openModal('login')">
                            <i class="align-middle material-icons">play_circle_outline</i> How to Login
                        </a>
                    </li>
                    <li>
                        <a href="#" class="link-style-white2" @click.prevent="openModal('bucket')">
                            <i class="align-middle material-icons">play_circle_outline</i> How to Use the “Bucket” Tool
                        </a>
                    </li>
                    <li>
                        <a href="#" class="link-style-white2" @click.prevent="openModal('white-label')">
                            <i class="align-middle material-icons">play_circle_outline</i> How to Use the “White Label” Tool
                        </a>
                    </li>
                </ul>
            </div>
            <div class="bubble-icon">
                <i v-on:click="seen = !seen" v-if="!seen" class="material-icons blue">help</i>
                <i v-on:click="seen = !seen" v-if="seen" class="material-icons blue">remove_circle</i>
            </div>
        </div>

        <!-- Chat and Phone Section -->
        <div id="footer-contact" class="row ">
            <div id="footer-chat" class="col align-self-center">
                <a href="sms:18002314095">
                    <i class="material-icons material-big blue">chat</i>
                    <p class="margin-0 d-none d-sm-block">Talk to a human, not a bot</p>
                    <p class="link-style d-none d-sm-block">Chat with us</p>
                </a>
            </div>
            <div id="footer-phone" class="col align-self-center">
                <a href="tel:18002314095">
                    <i class="material-icons material-big blue">phone</i>
                    <p class="margin-0 d-none d-sm-block">Call us or text us</p>
                    <p class="link-style d-none d-sm-block">+1 (800) 231-4095</p>
                </a>
            </div>
        </div>

        <!-- Email Subscribe Section -->
        <div v-if="currentUser" id="footer-newsletter" class="text-center row section-style">
            <email-subscribe-form :loading="loading" @submit="subscribe"></email-subscribe-form>
        </div>

        <!-- Links Section -->
        <div id="footer-info" class="text-left row section-style">
            <div class="container">
                <!-- <h2 class="text-center bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md white">Trust </h2> -->
                <div class="row">
                    <div class="col-12 col-sm-6 col-lg-6 col-xl-4">
                        <h3 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md white">Contact info</h3>
                        <ul class="white">
                            <li><address>2420 NE Miami Gardens Dr. <br>Ste 401, Aventura FL 33180</address></li>
                            <li><a class="link-style" href="tel:3058300200">Telephone: 305-830-0200</a></li>
                            <li><a class="link-style" href="tel:18002314095">Reservations: 1-800-231-4095</a></li>
                            <li><a class="link-style" :href="'mailto:'+companyInfo.email">{{ companyInfo.email }}</a></li>
                        </ul>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-6 col-xl-4">
                        <h3 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md white">Resources</h3>
                        <ul class="white">
                            <li>
                                <a class="link-style" href="https://docs.google.com/document/d/13DeRqNYJpXvTmru4k7JIpv391sZ3C9L5I-p1Iy0S0ug/edit?usp=sharing" target="_blank"><i class="material-icons">file_download</i> Download UJV Full Portfolio</a>
                            </li>
                            <li>
                                <a class="link-style" href="https://www.ultimatejetvacations.com/insurance"><i class="material-icons">airplanemode_active</i> Need travel protection?</a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-12 col-sm-12 col-lg-12 col-xl-4">
                        <h3 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md white">Helpful links</h3>
                        <div class="row">
                            <div class="col-sm-6">
                                <ul class="white">
                                    <router-link tag="li" :to="{name: 'home'}">
                                        <a class="link-style">Home</a>
                                    </router-link>
                                    <router-link tag="li" :to="{name: 'hotels'}">
                                        <a class="link-style">Hotels</a>
                                    </router-link>
                                    <router-link tag="li" :to="{name: 'destinations'}">
                                        <a class="link-style">Destinations</a>
                                    </router-link>
                                    <li>
                                        <a class="link-style" href="https://blog.ultimatejetvacations.com" target="_blank">Blog</a>
                                    </li>
                                    <router-link tag="li" :to="{name: 'map'}">
                                        <a class="link-style">Map</a>
                                    </router-link>
                                    <li>
                                        <a class="link-style" href="https://festiveavailability.ultimatejetvacations.com/">Festive</a>
                                    </li>
                                    <router-link tag="li" :to="{name: 'flights'}">
                                        <a class="link-style">Flights</a>
                                    </router-link>
                                    <router-link tag="li" :to="{name: 'careers'}">
                                        <a class="link-style">Careers</a>
                                    </router-link>
                                </ul>
                            </div>
                            <div class="col-sm-6">
                                <ul class="white">
                                    <router-link tag="li" :to="{name: 'about-us'}">
                                        <a class="link-style">About us</a>
                                    </router-link>
                                    <router-link tag="li" :to="{name: 'concierge'}">
                                        <a class="link-style">Concierge</a>
                                    </router-link>
                                    <li>
                                        <a class="link-style" href="https://landing.ultimatejetvacations.com/ujv-webinar-library">Webinar library</a>
                                    </li>
                                    <router-link tag="li" :to="{name: 'privacy-policy'}">
                                        <a class="link-style">Privacy policy</a>
                                    </router-link>
                                    <li>
                                        <a target="_blank" href="https://app.termly.io/document/terms-of-use-for-website/d3c4c226-c4f7-4ae8-b80c-6d03c04c6ed8" class="link-style">Terms of service</a>
                                    </li>
                                    <router-link tag="li" :to="{name: 'contact-us'}">
                                        <a class="link-style">Contact us</a>
                                    </router-link>
                                    <li>
                                        <a class="link-style" href="https://docs.google.com/document/d/13DeRqNYJpXvTmru4k7JIpv391sZ3C9L5I-p1Iy0S0ug/edit?usp=sharing" target="_blank">Hotel portfolio</a>
                                    </li>
                                    <router-link tag="li" :to="{name: 'faq'}">
                                        <a class="link-style">FAQ</a>
                                    </router-link>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Copyright Section -->
        <div id="footer-copyright" class="text-center row">
            <div class="col-12">
                <section-social-media></section-social-media>
            </div>
            <div class="col-12 copyright font-sm">
                <p class="white">Copyright &#169; {{ new Date().getFullYear() }} Ultimate Jet Vacations. All rights reserved.</p>
            </div>
        </div>

    </footer>
</template>

<script>
    import SectionSocialMedia from './SocialMedia';
    import EmailSubscribeForm from "./../forms/EmailSubscribeForm";
    import { HttpResponseStatus } from './../../services/Http/HttpResponse';
    import HelpRegisterModal from '../modals/help/HelpRegisterModal';
    import HelpLoginModal from '../modals/help/HelpLoginModal';
    import HelpBucketModal from '../modals/help/HelpBucketModal';
    import HelpWhiteLabelModal from '../modals/help/HelpWhiteLabelModal';
    import { mapGetters } from "vuex"
    export default {
        components: { SectionSocialMedia, EmailSubscribeForm, HelpLoginModal },
        created() {
            this.initialize();
        },
        computed: {
            ...mapGetters({
                currentUser: "Auth/user",
                currentUserLoading: "Auth/loading",
            }),
            brochureByMailUrl() {
                return [
                    "mailto:",
                    this.brochureByMail.to,
                    "?subject=",
                    this.brochureByMail.subject,
                    "&body=",
                    this.brochureByMail.body
                ].join("");
            },
            brochureByMail() {
                return {
                    to: this.companyInfo.email,
                    subject: "Request free Brochure by mail",
                    body: "Hi%20UJV%2C%0A%0AMy%20address%20is%3A%0A"
                }
            },
            isIframe() {
                return !!this.$route.query.iframe;
            },
        },
        data() {
            return {
                email: "",
                seen: false,
                loading: false,
                companyInfo: this.$store.getters["Company/companyInfo"],
            };
        },
        methods: {
            initialize() {
                this.$store.dispatch("Auth/fetchUser");
            },
            async subscribe(form) {
                if (this.loading) return;
                try {
                    this.loading = true;
                    let response = await this.$httpClient.request("post", "/api/actions/subscribe-email", form, true);
                    if(response.status === HttpResponseStatus.OK)
                    {
                        this.email = "";
                        this.$store.dispatch("Auth/fetchUser");
                    }
                } finally {
                    this.loading = false;
                }
            },
            /*
            openHelpRegisterModal() {
                this.$modal.show(HelpRegisterModal, {
                    draggable: false,
                    height: 'auto',
                    scrollable: true
                })
            },
            openHelpLoginModal() {
                this.$modal.show(HelpLoginModal, {
                    draggable: false,
                    height: 'auto',
                    scrollable: true
                })
            },
            openHelpBucketModal() {
                this.$modal.show(HelpBucketModal, {
                    draggable: false,
                    height: 'auto',
                    scrollable: true
                })
            },
            openHelpWhiteLabelModal() {
                this.$modal.show(HelpWhiteLabelModal, {
                    draggable: false,
                    height: 'auto',
                    scrollable: true
                })
            },
            */
            openModal(modal, props = {}) {
                let modalComponent = null;
                let options = {};
                switch (modal)
                {
                    case "register":
                        modalComponent = HelpRegisterModal;
                        options.width = "1000px";
                        break;
                    case "login":
                        modalComponent = HelpLoginModal;
                        options.width = "1000px";
                        break;
                    case "bucket":
                        modalComponent = HelpBucketModal;
                        options.width = "1000px";
                        break;
                    case "white-label":
                        modalComponent = HelpWhiteLabelModal;
                        options.width = "1000px";
                        break;
                }
                this.$modal.show(modalComponent, _.assign({}, props, {showGetQuote: !!this.currentUser}), _.assign({
                    draggable: false,
                    height: 'auto',
                    scrollable: true
                }, options));
            }
        }
    }
</script>

<style lang="scss" type="text/scss">
    /** Unique Index Styles **/
</style>
